// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { resultCountProps } from "@store/Themes/common/props/resultCount";
import constants from "@store/constants";
import { ShipmentsDataViewContext } from "@store/Framework/Store/Greif/Data/Shipments/ShipmentsSelectors";
import usePersistentDataView from "@toolkit/Framework/Common/Hooks/usePersistentDataView";
import React, { FC, useContext, useEffect, useState } from "react";

export interface ShipmentHistoryResultCountStyles {
    shipmentCountText?: TypographyPresentationProps;
}

export const resultCountStyles: ShipmentHistoryResultCountStyles = {
    shipmentCountText: resultCountProps.countText,
};

const styles = resultCountStyles;

const ShipmentHistoryResultCount: FC<WidgetProps> = () => {
    const shipmentsDataView = usePersistentDataView(useContext(ShipmentsDataViewContext));

    let itemCount = 0;
    const [totalItem, setTotalItem] = useState((shipmentsDataView as any)?.properties?.totalCount);

    if (shipmentsDataView.value && shipmentsDataView.pagination) {
        itemCount = shipmentsDataView.pagination.totalItemCount;
    }

    useEffect(() => {
        if (shipmentsDataView.value && shipmentsDataView?.properties?.totalCount) {
            setTotalItem((shipmentsDataView as any)?.properties?.totalCount);
        }
    }, [shipmentsDataView]);

    if (!shipmentsDataView.value || !shipmentsDataView.pagination) {
        return null;
    }

    return (
        <Typography {...styles.shipmentCountText} data-test-selector="shipmentHistory_resultCount">
            {totalItem ? `${translate("{0} of {1}", String(itemCount), String(totalItem))} ` : `${String(itemCount)} `}
            {totalItem === 1 ? translate("Shipment") : translate(`${"Shipments"}`)}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: ShipmentHistoryResultCount,
    definition: {
        group: constants.widgetGroup.shipmentHistory,
        displayName: "Result Count",
        allowedContexts: [""],
    },
};

export default widgetModule;
